import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ProviderUser } from '@magnetar/admin-api-interfaces'

interface ProviderUserResponse {
  success: boolean
  data: ProviderUser | null
  error?: {
    code: string
    message: string
  }
}

interface CreateNewUserAndAddToProviderRequest {
  provider_id: number
  account: string
  user_name: string
  email: string
  user_role_id?: number
}

export const providerUsersService = {
  createNewUserAndAddToProvider: async (
    data: CreateNewUserAndAddToProviderRequest,
    token: string,
  ): Promise<ProviderUserResponse> => {
    try {
      const response = await apiClient.post<ProviderUserResponse>(
        `/api/providers/${data.provider_id}/users`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ProviderUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_NEW_USER_FAILED',
          message: '建立新使用者失敗',
        },
      }
    }
  },

  // 更新 Provider 使用者的角色綁定（provider_users.user_role_id）
  updateProviderUserRole: async (
    providerId: number,
    providerUserId: number,
    userRoleId: number | null,
    token: string,
  ): Promise<ProviderUserResponse> => {
    try {
      const response = await apiClient.put<ProviderUserResponse>(
        `/api/providers/${providerId}/users/${providerUserId}`,
        { user_role_id: userRoleId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ProviderUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_PROVIDER_USER_ROLE_FAILED',
          message: '更新使用者角色失敗',
        },
      }
    }
  },

  deleteProviderUser: async (
    providerId: number,
    providerUserId: number,
    token: string,
  ): Promise<ProviderUserResponse> => {
    try {
      const response = await apiClient.delete<ProviderUserResponse>(
        `/api/providers/${providerId}/users/${providerUserId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ProviderUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'DELETE_PROVIDER_USER_FAILED',
          message: '刪除 Provider 使用者失敗',
        },
      }
    }
  },

  updateProviderUserPermissions: async (
    providerId: number,
    providerUserId: number,
    permissions: { module: string; allowed_action: string[] }[],
    token: string,
  ): Promise<{ success: boolean; error?: { code: string; message: string } }> => {
    try {
      const response = await apiClient.put<{ success: boolean }>(
        `/api/providers/${providerId}/users/${providerUserId}/permissions`,
        { permissions },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_PERMISSIONS_FAILED',
          message: '更新權限失敗',
        },
      }
    }
  },
}
